module.exports = __webpack_public_path__ + "img/vue-9-logo-svgrepo-com.ccc52047.svg";